import type { IdMap } from '@b-stock/fe-core/bstock-next/queries'
import {
  fetchAllResultsById,
  getStorefrontsClient,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { StoreFrontDto } from '@b-stock/listing-api-client'

export const fetchStorefrontsById = async (
  ids: string[],
  accessToken: string | null
): Promise<IdMap<StoreFrontDto>> => {
  if (!ids.length) return {}

  const apiClient = getStorefrontsClient()

  const listings = await fetchAllResultsById({
    apiClient,
    axiosOptions: buildAxiosRequestConfig({ accessToken }),
    getQueryParameters: (id, limit) => ({ id, limit }),
    ids,
    limit: 100,
    query: apiClient.findAllStoreFronts,
    responseToResults: (o) => o.storeFronts,
  })

  return listings.reduce<IdMap<StoreFrontDto>>((acc, o) => {
    if (o._id) acc[o._id] = o
    return acc
  }, {})
}
